<template>
    <div class="layout--main">
        <div id="content-area">
            <div id="content-overlay" />
            <template>
                <the-header />
            </template>

            <div class="content-wrapper">
                        
                <div class="content-area__content">
                    
                    <div class="site-wrapper-reveal">
                        <div class="about-banner-wrap banner-space about-us-bg relative">
                            <div class="banner-overlay"></div>
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-8 ml-auto mr-auto">
                                        <div class="about-banner-content text-center relative">
                                            <h1 class="mb-4 text-white">{{ routeTitle }}</h1>
                                            <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
                        <vs-button radius icon-pack="feather" icon="icon-arrow-up" class="shadow-lg vs-scroll-top btn-back-to-top" />
                    </back-to-top>
                    
                    <div class="router-view">
                        <div class="router-content">
                            <div class="container">
                                <transition>
                                    <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <the-footer />
        </div>
    </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'

export default {
  components: {
    BackToTop,
    TheFooter,
    TheHeader
  },
  data () {
    return {      
      hideScrollToTop   : themeConfig.hideScrollToTop,
      routeTitle        : this.$route.meta.pageTitle
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    }
  },
  computed: {
    isAppPage () {
      return this.$route.meta.no_scroll
    }
  },
  methods: {
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    }
  },
  created () {
  },
  beforeDestroy () {
  }
}

</script>